import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-bmi-label',
  templateUrl: './bmi-label.component.html',
})
export class BmiLabelComponent implements OnChanges {

  @Input() height: number;
  @Input() weight: number;
  bmi: number;
  bmiColor = '';
  bmiDetails = '';
  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    this.bmi = 0;
    if (this.height > 0 && this.weight > 0) {
      this.bmi = this.weight / Math.pow((this.height / 100), 2);

      if (this.bmi < 18.5){
        this.bmiColor = 'color: blue';
        this.bmiDetails = 'Maigreur';
      } else if (this.bmi < 25) {
        this.bmiColor = 'color: green';
        this.bmiDetails = 'Normal';
      } else if (this.bmi < 30) {
        this.bmiColor = 'color: orange';
        this.bmiDetails = 'Surpoids';
      } else if (this.bmi < 40) {
        this.bmiColor = 'color: orangered';
        this.bmiDetails = 'Obésité modérée';
      }  else {
        this.bmiColor = 'color: red';
        this.bmiDetails = 'Obésité sévère';
      }
    }
  }
}
